export var AppLockReason;
(function (AppLockReason) {
    AppLockReason["PostSettlementSettled"] = "POST_SETTLEMENT_SETTLED";
    AppLockReason["PostSettlementDischarged"] = "POST_SETTLEMENT_DISCHARGED";
    AppLockReason["ClosedLostLost"] = "CLOSED_LOST_LOST";
    AppLockReason["ClosedLostDeclined"] = "CLOSED_LOST_DECLINED";
    AppLockReason["RetiredDomainBrand"] = "RETIRED_DOMAIN_BRAND";
    AppLockReason["SubmittedToLender"] = "SUBMITTED_TO_LENDER";
    AppLockReason["PreApproved"] = "PRE_APPROVED";
    AppLockReason["Settlement"] = "SETTLEMENT";
})(AppLockReason || (AppLockReason = {}));
//# sourceMappingURL=AppLockReason.js.map